module.exports = __webpack_public_path__ + "static/media/new-collection.96c114e7.svg";